import { Menu, MenuItem, PopoverPosition } from "@mui/material";
import { useNotification } from "app/NotificationProvider";
import { mixpanel } from "common/analytics";
import { useTranslation } from "common/locales";
import { differenceInDays } from "date-fns";
import { FileEntry, useAppDispatch, useAppSelector } from "model";
import { Dispatch, SetStateAction } from "react";
import { downloadFileHelper } from "./downloadFileHelper";

export const FILE_EDIT_PERIOD_DAYS = 30;

interface Props {
  fileEntry: FileEntry;
  anchor: HTMLElement | null;
  anchorPosition?: PopoverPosition;
  close: () => void;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
  setDeleteDialogOpen: Dispatch<SetStateAction<boolean>>;
}
export default function FileEntryMoreMenu({
  fileEntry,
  anchor,
  anchorPosition,
  close,
  setDialogOpen,
  setDeleteDialogOpen,
}: Props) {
  const dispatch = useAppDispatch();
  const { notify } = useNotification();
  const { t } = useTranslation();

  const user = useAppSelector((state) => state.user.details);
  const canEdit =
    differenceInDays(
      Date.now(),
      fileEntry.creationDate ? new Date(fileEntry.creationDate) : Date.now()
    ) <= FILE_EDIT_PERIOD_DAYS && fileEntry.userId === user?.guid;

  return (
    <Menu
      anchorEl={anchor}
      anchorPosition={anchorPosition}
      anchorReference={
        anchor ? "anchorEl" : anchorPosition ? "anchorPosition" : "none"
      }
      open={anchor ? anchor.id === fileEntry.guid : false}
      onClose={close}
      key={`fileEntry-menu-${fileEntry.guid}`}
    >
      <MenuItem
        key={`fileEntry-menuitem-download-${fileEntry.guid}`}
        onClick={async () => {
          mixpanel.track("Download fileEntry event clicked");
          await downloadFileHelper(fileEntry.guid, dispatch, notify);
          close();
        }}
      >
        {t("fileEntry.menu.download")}
      </MenuItem>
      {canEdit && (
        <div>
          <MenuItem
            key={`fileEntry-menuitem-edit-${fileEntry.guid}`}
            onClick={() => {
              mixpanel.track("Edit/view fileEntry event clicked");
              setDialogOpen(true);
              close();
            }}
          >
            {t("fileEntry.menu.editView")}
          </MenuItem>
          <MenuItem
            key={`fileEntry-menuitem-delete-${fileEntry.guid}`}
            onClick={() => {
              mixpanel.track("Delete fileEntry event clicked");
              setDeleteDialogOpen(true);
              close();
            }}
          >
            {t("fileEntry.menu.delete")}
          </MenuItem>
        </div>
      )}
    </Menu>
  );
}
